module.exports = __webpack_public_path__ + "9e2a9f57c65e528cde272c27a9affbd7.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/winking-31.png
// module id = 2399
// module chunks = 0